mutation DeleteApplicationFromApplicationConsole(
    $domain: String!
) {
    deleteApplication(
        domain: $domain
    )
}
